import React from 'react';
import './styles.css';
import Icon from '../Icon';
import { Switch, NavLink, Route } from 'react-router-dom';
import {
	INCOMESTATEMENT,
	BALANCESHEET,
	CASHFLOW,
	EXPORTREPORTS,
	SALESTEST,
	SALESPROGRAM,
	PRODUCTIONPROGRAM,
	PRODUCTIONINTERNALLY,
	PRODUCTIONEXTERNALLY,
	PRODUCTIONQUALITYCHECK,
	PRODUCTIONFIXEDCOSTS,
	PROCUREMENTOVERVIEW,
	PROCUREMENTSUPPLIER,
	PROCUREMENTINVENTORY,
	PROCUREMENTCOST
} from '../../routes';
import { formatRoute } from 'react-router-named-routes';

const BusinessPlanNextButton = ({ game, match }) => {
	const paths = [
		SALESTEST,
		SALESPROGRAM,
		PRODUCTIONPROGRAM,
		PRODUCTIONINTERNALLY,
		PRODUCTIONEXTERNALLY,
		PRODUCTIONQUALITYCHECK,
		PRODUCTIONFIXEDCOSTS,
		PROCUREMENTOVERVIEW,
		PROCUREMENTSUPPLIER,
		PROCUREMENTINVENTORY,
		PROCUREMENTCOST,
		INCOMESTATEMENT,
		BALANCESHEET,
		CASHFLOW,
		EXPORTREPORTS
	];
	return (
		<Switch>
			{paths.map(path => (
				<Route
					path={path}
					render={() => {
						const nextIndex = paths.indexOf(path) + 1;
						return nextIndex < paths.length ? (
							<NavLink
								to={formatRoute(paths[nextIndex], {
									gameID: game.id,
									businessPlanID: match.params.businessPlanID
								})}
								className="business-plan-next-button"
							>
								Next
								<Icon icon="nextArrow" />
							</NavLink>
						) : null;
					}}
					key={path}
				/>
			))}
		</Switch>
	);
};

export default BusinessPlanNextButton;
